import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Unauthorized } from '../../components/layout/security/Unauthorized';
import { canAccessAtsRoute, getDefaultAtsPath } from './rolePermissions';

export function RoleRoute({ path, children, ...routeProps }) {
	return (
		<Route
			{...routeProps}
			path={path}
			render={({ match, location }) => {
				const atsRouteSuffix = location.pathname.replace(match.path, '');
				if (!canAccessAtsRoute(atsRouteSuffix)) {
					if (location.pathname === match.url) {
						return <Redirect to={getDefaultAtsPath()} />;
					}
					return <Unauthorized />;
				}
				return children;
			}}
		/>
	);
}
